// src/components/NewsCard.jsx
import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { THUMB_BASE_URL } from "../config";

const DEFAULT_THUMBNAIL = "/default-thumb.jpg";

function formatDate(ts) {
  if (!ts) return "";
  const d = new Date(ts);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("mr-IN", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
}

const NewsCard = ({ item, index, category, relatedStories = [] }) => {
  const isHighlight = String(item.highlight).toLowerCase() === "true";
  const layoutClass = index % 2 === 0 ? "row" : "row-reverse";

  const thumbnailUrl = item.thumbnail
    ? `${THUMB_BASE_URL}${item.thumbnail}`
    : DEFAULT_THUMBNAIL;

  const [thumbSrc, setThumbSrc] = useState(thumbnailUrl);

  useEffect(() => {
    setThumbSrc(thumbnailUrl);
  }, [thumbnailUrl]);

  const onImgError = () => {
    if (thumbSrc !== DEFAULT_THUMBNAIL) setThumbSrc(DEFAULT_THUMBNAIL);
  };

  const snippet = item.snippet || "";

  return (
    <Link
      to={`/story/${encodeURIComponent(item.uniq_link)}`}
      state={{ category, relatedStories }}
      className={`news-card ${layoutClass} ${isHighlight ? "highlight" : ""}`}
      style={{ textDecoration: "none", color: "inherit" }}
    >
      <div className="news-card-content">
        <div className="news-card-title">{item.title}</div>
        <div className="news-card-date">{formatDate(item.added_on)}</div>

        {isHighlight && snippet && (
          <div className="news-card-snippet">
            {snippet.length > 120 ? snippet.slice(0, 120) + "…" : snippet}
          </div>
        )}

        <div className="read-more-link">सविस्तर बातमी →</div>
      </div>

      <img
        src={thumbSrc}
        alt={item.title}
        className="news-card-thumbnail"
        loading="lazy"
        onError={onImgError}
      />
    </Link>
  );
};

export default NewsCard;
